import React from "react";
import { Home } from "./pages/Home";
import { NonAdmin } from "./pages/NonAdmin";
import { useAuthenticatedUserState } from "./providers/AuthenticatedUserProvider";

export const Main = () => {
  const { isAdmin } = useAuthenticatedUserState();

  if (!isAdmin) {
    return <NonAdmin />;
  }

  return <Home />;
};
